// extracted by mini-css-extract-plugin
export default {"recipeTitleImage":"G730f5c G519ebe","recipeImage":"G905101","recipeTitle":"G63a5c4 G519ebe","recipeRadioButtonGroup":"G55f476"};